import z from 'zod'

/** Display rotation in degrees (clockwise), as used by the player ScreenService and app remote control. */
export const screenRotationSchema = z.enum(['0', '90', '180', '270'])

export type TScreenRotation = z.infer<typeof screenRotationSchema>

/** Horizontal layouts use 0° or 180°; vertical use 90° or 270°. */
export const screenOrientationSchema = z.enum(['horizontal', 'vertical'])

export type TScreenOrientation = z.infer<typeof screenOrientationSchema>
